import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=b011e08e&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=b011e08e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b011e08e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b011e08e')) {
      api.createRecord('b011e08e', component.options)
    } else {
      api.reload('b011e08e', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=b011e08e&scoped=true&", function () {
      api.rerender('b011e08e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hL6y5aYIk7wu/JS/comp/GuestBox.vue"
export default component.exports